<template>
  <div>
    <Layout :pagetitle="$t('Sub Brand')">
      <form autocomplete="off" @submit.prevent="saveSubBrand">
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Sub Brand') }}</h4>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col class="mt-2" md="4">
              <label>{{ $t('Brand') }}</label>
              <brandSelectorUnique :modelValue="idBrand" @onChange="setBrand" />
            </b-col>
            <b-col class="mt-2" md="4" v-if="permissionRewardProfile">
              <label>{{ $t('Reward Profile') }}</label>
              <rewardProfileSelector :modelValue="idRewardProfile" @onChange="selectProfile" />
            </b-col>
            <b-col class="mt-2" md="4">
              <label>{{ $t('Name') }}</label>
              <b-form-input :trim="true" autocomplete="off" required v-model="name" />
            </b-col>
            <b-col class="mt-2" md="4">
              <label>
                {{ 'URL Advertising' }}
                <i
                  class="text-small mdi mdi-information"
                  :title="$t('Linked affiliate traffic will be redirected to this url')"
                />
              </label>
              <b-form-input :trim="true" autocomplete="off" v-model="site" />
            </b-col>
            <b-col class="mt-2" md="4">
              <label>{{ $t('Active') }}</label>
              <select class="form-control">
                <option :value="true">{{ $t('Yes') }}</option>
                <option :value="false">{{ $t('No') }}</option>
              </select>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <h3>
                {{ $t('Actions By Domain') }}
                <small>
                  <i
                    class="text-small mdi mdi-information"
                    :title="
                      $t(
                        'Nos domínios autorizados do site é possível configurar para que cadastros por tráfego de forma orgânica sejam associados a uma ação (habilitaAcaoDominioAfiliado).'
                      )
                    "
                  />
                </small>
              </h3>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col class="mt-2" md="6">
              <label>{{ $t('Domain') }}</label>
              <b-form-input :trim="true" autocomplete="off" v-model="domain" />
            </b-col>
            <b-col class="mt-2" md="6">
              <label>{{ $t('Action') }} ({{ $t('Affiliate') }})</label>
              <generic-selector
                @onChange="setActionByDomain"
                :returnedField="'action_name'"
                :returnedPk="'action_id'"
                entity="action/all"
                :modelValue="actionByDomain"
              />
            </b-col>
            <b-col class="d-flex justify-content-end" md="12">
              <div class="mt-3">
                <button class="btn btn-primary btn-sm" type="button" @click="addActionByDomain">
                  {{ $t('Add Action By Domain') }}
                </button>
              </div>
            </b-col>
          </b-row>
          <b-table
            v-if="!loading && actionsByDomain.length ? true : false"
            :fields="actionsByDomainStatic.fields"
            :items="actionsByDomain"
            responsive
            striped
            hover
            class="mt-2"
          >
            <template #cell(actions)="data">
              <button type="button" class="btn btn-primary btn-sm" @click="removeActionByDomain(data)">
                {{ $t('Remove') }}
              </button>
            </template>
            <template #cell(url)="data">
              <span>
                <a :href="data.item.url" target="_blank">{{ data.item.url }}</a>
              </span>
            </template>
          </b-table>
          <hr />
          <b-row>
            <b-col>
              <h3>
                {{ $t('Geolocation') }}
                <small>
                  <i
                    class="text-small mdi mdi-information"
                    :title="
                      $t(
                        'Para habilitar a Geolocalização no site é necessário ativar a flag no Atena (verificaGeolocalizacaoAfiliado) na localidade Web.'
                      )
                    "
                  />
                </small>
              </h3>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col class="mt-2" md="6">
              <label>{{ $t('Action') }} ({{ $t('Affiliate') }})</label>
              <generic-selector
                @onChange="setAction"
                :returnedField="'action_name'"
                :returnedPk="'action_id'"
                entity="action/all"
                :modelValue="actionId"
              />
            </b-col>
            <b-col class="mt-2" md="6">
              <label>{{ $t('Country') }}</label>
              <generic-selector @onChange="setCountry" entity="country" :modelValue="countryId" />
            </b-col>
            <b-col class="mt-2" md="6">
              <label>{{ $t('State') }}</label>
              <generic-selector
                @onChange="setState"
                entity="state"
                :modelValue="stateId"
                :isDisabled="!countryId"
              />
            </b-col>
            <b-col class="mt-2" md="6">
              <label>{{ $t('City') }}</label>
              <generic-selector
                @onChange="setCity"
                entity="city"
                :modelValue="cityId"
                :filterField="'stateId'"
                :filterValue="stateId"
                :isDisabled="!stateId"
              />
            </b-col>
            <b-col class="d-flex justify-content-end" md="12">
              <div class="mt-3">
                <button class="btn btn-primary btn-sm" type="button" @click="addGeolocation">
                  {{ $t('Add Geolocation') }}
                </button>
              </div>
            </b-col>
          </b-row>
          <b-table
            v-if="!loading && geolocation.length ? true : false"
            :fields="geolocationStatic.fields"
            :items="geolocation"
            responsive
            striped
            hover
            class="mt-2"
          >
            <template #cell(actions)="data">
              <button type="button" class="btn btn-primary btn-sm" @click="removeGeolocation(data)">
                {{ $t('Remove') }}
              </button>
            </template>
            <template #cell(url)="data">
              <span>
                <a :href="data.item.url" target="_blank">{{ data.item.url }}</a>
              </span>
            </template>
          </b-table>
        </b-card>
        <b-row>
          <div>
            <button
              type="submit"
              class="btn btn-primary m-1"
              v-if="$route.params.id"
              :disabled="$store.state.isLoading"
            >
              {{ $t('Update') }}
            </button>
            <button type="submit" class="btn btn-primary m-1" :disabled="$store.state.isLoading" v-else>
              {{ $t('Create') }}
            </button>
            <button type="button" class="btn btn-secondary m-1" @click="$router.back()">
              {{ $t('Back') }}
            </button>
          </div>
        </b-row>
      </form>
    </Layout>
  </div>
</template>

<script>
import geolocationStatic from './geolocationStatic';
import actionsByDomainStatic from './actionsByDomainStatic';
import Layout from '@/views/layouts/main';
import brandSelectorUnique from '@/components/selectors/brandSelectorUnique';
import rewardProfileSelector from '@/components/selectors/rewardProfileSelector';

export default {
  components: { Layout, rewardProfileSelector, brandSelectorUnique },
  data() {
    return {
      name: '',
      country: '',
      state: '',
      city: '',
      countryId: null,
      stateId: null,
      cityId: null,
      actionId: null,
      geolocationStatic: geolocationStatic(),
      actionsByDomainStatic: actionsByDomainStatic(),
      geolocation: [],
      actionsByDomain: [],
      idBrand: null,
      isActive: true,
      site: '',
      idRewardProfile: null,
      metadata: {},
      loading: false,
      actionByDomain: null,
      domain: ''
    };
  },
  mounted() {
    if (this.$route.params?.id) {
      this.getSubBrand();
    }
  },
  methods: {
    selectProfile(reward_profile_id) {
      this.idRewardProfile = reward_profile_id;
    },
    setBrand(brand) {
      this.idBrand = brand;
    },
    setActionByDomain(action) {
      this.actionByDomain = action;
    },
    setAction(action) {
      this.actionId = action;
    },
    saveSubBrand() {
      if (this.$route.params?.id) {
        this.updateSubBrand();
      } else {
        this.createSubBrand();
      }
    },
    getSubBrand() {
      const subBrandId = this.$route.params.id;
      this.$store.commit('SET_LOADING', true);

      this.$api
        .get(`api/subBrand/${subBrandId}`, {})
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          let subBrand = res.data;

          this.name = subBrand.name;
          this.metadata = subBrand?.metadata || {};
          this.geolocation = this.metadata?.geolocation || [];
          this.actionsByDomain = this.metadata?.actionsByDomain || [];
          this.idBrand = subBrand.id_brand;
          this.isActive = subBrand.is_active;
          this.site = subBrand.site;
          this.idRewardProfile = subBrand?.id_reward_profile || null;

          this.reloadActionInfo();
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: this.$t('Error')
          });
        });
    },
    createSubBrand() {
      if (!this.validateSubBrand()) return;

      let geolocation = this.getGeolocationConfig();
      let actionsByDomain = this.getActionsById();

      let subBrand = {
        name: this.name,
        metadata: { geolocation: geolocation, actionsByDomain: actionsByDomain },
        idBrand: this.idBrand,
        isActive: this.isActive,
        site: this.site,
        idRewardProfile: this?.idRewardProfile || null
      };

      this.$store.commit('SET_LOADING', true);
      this.$api
        .post('api/subBrand', subBrand)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });

          this.$router.push({
            name: 'subBrandList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Create subBrand error')
          });
        });
    },
    setCountry(id, object) {
      this.country = object?.data?.iso2 || '';
      this.countryId = id;
    },
    setState(id, object) {
      this.state = object?.data?.acronym || '';
      this.stateId = id;
      this.cityId = null;
    },
    setCity(id, object) {
      this.city = object?.data?.name || '';
      this.cityId = id;
    },
    removeActionByDomain(item) {
      let index = 0;
      for (const actionByDomain of this.actionsByDomain) {
        if (actionByDomain.domain == item.item.domain && actionByDomain.actionId == item.item.actionId) {
          this.actionsByDomain.splice(index, 1);
          return;
        }
        index++;
      }

      this.reloadActionInfo();
    },
    addActionByDomain() {
      if (!this.domain || !this.actionByDomain) return;

      this.actionsByDomain.push({
        actionId: `${this.actionByDomain}`,
        domain: `${this.domain}`
      });

      this.actionByDomain = null;
      this.domain = '';

      this.reloadActionInfo();
    },
    removeGeolocation(item) {
      let index = 0;
      for (const geoloc of this.geolocation) {
        if (
          geoloc.country == item.item.country &&
          geoloc.state == item.item.state &&
          geoloc.city == item.item.city &&
          geoloc.actionId == item.item.actionId
        ) {
          this.geolocation.splice(index, 1);
          return;
        }
        index++;
      }

      this.reloadActionInfo();
    },
    addGeolocation() {
      if (!this.country || !this.state || !this.city || !this.actionId) return;

      this.geolocation.push({
        country: `${this.country}`,
        state: `${this.state}`,
        city: `${this.city}`,
        actionId: this.actionId
      });

      this.country = '';
      this.state = '';
      this.city = '';
      this.actionId = null;
      this.countryId = null;
      this.stateId = null;
      this.cityId = null;

      this.reloadActionInfo();
    },
    getActionsById() {
      return this.actionsByDomain.map((actionByDomain) => {
        return {
          actionId: parseInt(actionByDomain?.actionId || 0) || null,
          domain: actionByDomain.domain
        };
      });
    },
    getGeolocationConfig() {
      return this.geolocation.map((geoloc) => {
        return {
          country: geoloc.country,
          state: geoloc.state,
          city: geoloc.city,
          actionId: parseInt(geoloc?.actionId || 0) || null
        };
      });
    },
    updateSubBrand() {
      if (!this.validateSubBrand()) return;
      let subBrandId = this.$route.params.id;
      let geolocation = this.getGeolocationConfig();
      let actionsByDomain = this.getActionsById();

      let subBrand = {
        name: this.name,
        metadata: { geolocation: geolocation, actionsByDomain: actionsByDomain },
        idBrand: this.idBrand,
        isActive: this.isActive,
        site: this.site,
        idRewardProfile: this?.idRewardProfile || null
      };

      this.$store.commit('SET_LOADING', true);
      this.$api
        .put(`api/subBrand/${subBrandId}`, subBrand)
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Success')
          });
          this.$router.push({
            name: 'subBrandList'
          });
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Update subBrand error')
          });
        });
    },
    validateSubBrand() {
      if (!this.name) {
        this.$customAlert({
          msg: this.$t('Invalid name'),
          type: 'error'
        });
        return false;
      }

      if (!this.idBrand) {
        this.$customAlert({
          msg: this.$t('Invalid brand'),
          type: 'error'
        });
        return false;
      }
      return true;
    },
    reloadActionInfo() {
      let actionIds = [];

      if (this.geolocation?.length) {
        for (const geoloc of this.geolocation) {
          actionIds.push(parseInt(geoloc.actionId));
        }
      }

      if (this.actionsByDomain?.length) {
        for (const actionByDomain of this.actionsByDomain) {
          actionIds.push(parseInt(actionByDomain.actionId));
        }
      }

      actionIds = Array.from(new Set(actionIds));

      if (actionIds?.length) {
        this.loading = true;
        this.$api.get(`api/action/all?ids=${actionIds.join(',')}`).then((res) => {
          this.loading = false;

          if (this.geolocation?.length) {
            this.geolocation = this.geolocation.map((geoloc) => {
              for (let action of res.data) {
                if (geoloc.actionId == action.action_id) {
                  geoloc = {
                    ...action,
                    url: (action?.brand_settings?.urlAdvertising || '') + action.action_token,
                    ...geoloc
                  };
                }
              }
              return geoloc;
            });
          }

          if (this.actionsByDomain?.length) {
            this.actionsByDomain = this.actionsByDomain.map((byd) => {
              for (let action of res.data) {
                if (byd.actionId == action.action_id) {
                  byd = {
                    ...action,
                    url: (action?.brand_settings?.urlAdvertising || '') + action.action_token,
                    ...byd
                  };
                }
              }
              return byd;
            });
          }
        });
      }
    }
  },
  computed: {
    permissionRewardProfile() {
      return this.$utils.checkRole('rewardProfile');
    }
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
